import { render } from "./Forbidden.vue?vue&type=template&id=b55c8508&scoped=true"
const script = {}

import "./Forbidden.vue?vue&type=style&index=0&id=b55c8508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b55c8508"]])

export default __exports__